import React from 'react'
import { reduxForm, Field, SubmissionError } from 'redux-form'
import { withRouter } from 'react-router-dom'

import { FormLabel, MultiSearch, Notification, commaInSearch } from '@offerzen/pinata-shame'

import BellIcon from '@offerzen/zenicon/BellIcon'
import { previousOnboardingUrl } from '../../helpers/onboardingSteps'
import CardFooterNav from '../CardFooterNav/CardFooterNav'

import styles from './styles'

const validators = {
  commaInSearch: commaInSearch('Please search for one skill at a time'),
}

const SkillsForm = ({ selectedSkillsCount, ...props }) => (
  <form className={styles.form} onSubmit={props.handleSubmit}>
    <div className={styles.fields}>
      <If condition={selectedSkillsCount >= 10}>
        <Notification className={styles.notification} icon={BellIcon} theme="dark">
          You have reached the limit of skills.
        </Notification>
      </If>

      <FormLabel htmlFor="skills" label="Top skills" />
      <Field
        name="skills"
        id="skills"
        className={styles.field}
        placeholder="Search for a skill"
        onSearch={props.searchSkills}
        fetching={props.searching}
        results={props.searchResults}
        disabled={selectedSkillsCount >= 10}
        onChange={props.clearErrors}
        onRemove={skill => props.trackRemovedSkill(skill.label)}
        warn={validators.commaInSearch}
        component={MultiSearch}
        autoFocus
        canSelectSearchTerm
      />

      <If condition={props.error}>
        <Notification className={styles.notification} theme="error">
          {props.error}
        </Notification>
      </If>

      <CardFooterNav
        theme="primary"
        navigateBack={() => props.history.push(previousOnboardingUrl(props.location.pathname))}
        className={styles.footer}
        loading={props.submitting}
      />
    </div>
  </form>
)

export default withRouter(
  reduxForm({
    form: 'skills',
    onSubmit: (values, _, props) => {
      const data = values.skills.filter(elem => !!elem.value).map(elem => elem.value)

      if (data.length < 1) {
        throw new SubmissionError({
          _error: 'Please add at least one skill before continuing.',
        })
      }

      return new Promise((resolve, reject) => props.updateSkills(data, resolve, reject))
    },
    onSubmitSuccess: (_, __, props) => props.goToNextStep(),
  })(SkillsForm),
)
